import {
  ContentMethodEmbed,
  ContentMethodRichText,
  ContentMethodUpload
} from "../../manage/methods"

export default {
  EMBED: {
    key: "AudioEmbed",
    fieldsData: {
      audio_embed_code: {
        placeholder: "Paste embed code to reading document",
        action_prompt: "Load reading"
      }
    },
    getValues(content) {
      const values = {
        audio_embed_code: content != null ? content.audio_embed_code : undefined
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = { audio_embed_code: fieldsData.audio_embed_code.value }
      return saveData
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodEmbed
          allowToggle={false}
          defaultMode="embed_code"
          codeProps={fieldsData.audio_embed_code}
        />
      )
    }
  },

  LISTED: {
    key: "AudioListed",
    fieldsData: {
      listed_instructions: {
        placeholder: "Write or paste in the audio content..."
      }
    },
    getValues(content) {
      const values = {
        listed_instructions:
          content != null ? content.listed_instructions : undefined
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = {
        listed_instructions: fieldsData.listed_instructions.value
      }
      return saveData
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodRichText
          {...Object.assign({}, fieldsData.listed_instructions)}
        />
      )
    }
  },

  UPLOAD: {
    key: "AudioUpload",
    fieldsData: {
      audio: {
        placeholder: "Upload your audio file...",
        mediaType: "audio"
      }
    },
    getValues(content) {
      const values = {
        audio: {
          url: content != null ? content.audio_file_url : undefined,
          filename: content != null ? content.name : undefined
        }
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = {
        audio_file_url:
          fieldsData.audio.value != null
            ? fieldsData.audio.value.url
            : undefined,
        name:
          fieldsData.audio.value != null
            ? fieldsData.audio.value.filename
            : undefined
      }
      return saveData
    },
    renderForm({ fieldsData }) {
      return <ContentMethodUpload {...Object.assign({}, fieldsData.audio)} />
    }
  }
}
